// extracted by mini-css-extract-plugin
export default {"container-card":"SectionCard_container-card__s4XJL","container":"SectionCard_container__CIJUw","title":"SectionCard_title__DHntb","subtitle":"SectionCard_subtitle__BVnzC"};